var items = {
  "block.minecraft.air": "aer",
  "block.minecraft.stone": "carreg",
  "block.minecraft.granite": "gwenithfaen",
  "block.minecraft.polished_granite": "gwenithfaen caboledig",
  "block.minecraft.diorite": "diorit",
  "block.minecraft.polished_diorite": "diorit caboledig",
  "block.minecraft.andesite": "andesit",
  "block.minecraft.polished_andesite": "andesit caboledig",
  "block.minecraft.grass_block": "bloc glaswellt",
  "block.minecraft.dirt": "pridd",
  "block.minecraft.coarse_dirt": "pridd garw",
  "block.minecraft.podzol": "podsol",
  "block.minecraft.crimson_nylium": "neliwm rhuddgoch",
  "block.minecraft.warped_nylium": "neliwm annaearol",
  "block.minecraft.cobblestone": "crynion",
  "block.minecraft.oak_planks": "planciau derw",
  "block.minecraft.spruce_planks": "planciau pyrwydd",
  "block.minecraft.birch_planks": "planciau bedw",
  "block.minecraft.jungle_planks": "planciau jyngl",
  "block.minecraft.acacia_planks": "planciau acesia",
  "block.minecraft.dark_oak_planks": "planciau derw tywyll",
  "block.minecraft.crimson_planks": "planciau rhuddgoch",
  "block.minecraft.warped_planks": "planciau annaearol",
  "block.minecraft.oak_sapling": "glasbren derw",
  "block.minecraft.spruce_sapling": "glasbren pyrwydd",
  "block.minecraft.birch_sapling": "glasbren bedw",
  "block.minecraft.jungle_sapling": "glasbren jyngl",
  "block.minecraft.acacia_sapling": "glasbren acesia",
  "block.minecraft.dark_oak_sapling": "glasbren derw tywyll",
  "block.minecraft.bedrock": "creigwely",
  "block.minecraft.sand": "tywod",
  "block.minecraft.red_sand": "tywod coch",
  "block.minecraft.gravel": "graean",
  "block.minecraft.gold_ore": "mwyn aur",
  "block.minecraft.iron_ore": "mwyn haearn",
  "block.minecraft.coal_ore": "mwyn glo",
  "block.minecraft.nether_gold_ore": "mwyn aur nether",
  "block.minecraft.oak_log": "boncyff derw",
  "block.minecraft.spruce_log": "boncyff pyrwydd",
  "block.minecraft.birch_log": "boncyff bedw",
  "block.minecraft.jungle_log": "boncyff jyngl",
  "block.minecraft.acacia_log": "boncyff acesia",
  "block.minecraft.dark_oak_log": "boncyff derw tywyll",
  "block.minecraft.crimson_stem": "coesyn rhuddgoch",
  "block.minecraft.warped_stem": "coesyn annaearol",
  "block.minecraft.stripped_oak_log": "boncyff derw moel",
  "block.minecraft.stripped_spruce_log": "boncyff pyrwydd moel",
  "block.minecraft.stripped_birch_log": "boncyff bedw moel",
  "block.minecraft.stripped_jungle_log": "boncyff jyngl moel",
  "block.minecraft.stripped_acacia_log": "boncyff acesia moel",
  "block.minecraft.stripped_dark_oak_log": "boncyff derw tywyll moel",
  "block.minecraft.stripped_crimson_stem": "coesyn rhuddgoch moel",
  "block.minecraft.stripped_warped_stem": "coesyn annaearol moel",
  "block.minecraft.stripped_oak_wood": "pren derw moel",
  "block.minecraft.stripped_spruce_wood": "pren pyrwydd moel",
  "block.minecraft.stripped_birch_wood": "pren bedw moel",
  "block.minecraft.stripped_jungle_wood": "coed jyngl moel",
  "block.minecraft.stripped_acacia_wood": "pren acesia moel",
  "block.minecraft.stripped_dark_oak_wood": "pren derw tywyll moel",
  "block.minecraft.stripped_crimson_hyphae": "hyffae rhuddgoch moel",
  "block.minecraft.stripped_warped_hyphae": "hyffae annaearol moel",
  "block.minecraft.oak_wood": "pren derw",
  "block.minecraft.spruce_wood": "pren pyrwydd",
  "block.minecraft.birch_wood": "pren bedw",
  "block.minecraft.jungle_wood": "pren jyngl",
  "block.minecraft.acacia_wood": "pren acesia",
  "block.minecraft.dark_oak_wood": "pren derw tywyll",
  "block.minecraft.crimson_hyphae": "hyffae rhuddgoch",
  "block.minecraft.warped_hyphae": "hyffae annaearol",
  "block.minecraft.oak_leaves": "dail derw",
  "block.minecraft.spruce_leaves": "dail pyrwydd",
  "block.minecraft.birch_leaves": "dail bedw",
  "block.minecraft.jungle_leaves": "dail jyngl",
  "block.minecraft.acacia_leaves": "dail acesia",
  "block.minecraft.dark_oak_leaves": "dail derw tywyll",
  "block.minecraft.sponge": "sbwng",
  "block.minecraft.wet_sponge": "spwng gwlyb",
  "block.minecraft.glass": "gwydr",
  "block.minecraft.lapis_ore": "mwyn lapis-laswli",
  "block.minecraft.lapis_block": "bloc lapis-laswli",
  "block.minecraft.dispenser": "dosbarthwr",
  "block.minecraft.sandstone": "tywodfaen",
  "block.minecraft.chiseled_sandstone": "tywodfaen nadd",
  "block.minecraft.cut_sandstone": "tywodfaen toredig",
  "block.minecraft.note_block": "bloc nodyn",
  "block.minecraft.powered_rail": "cledren â phŵer",
  "block.minecraft.detector_rail": "cledren synhwyrydd",
  "block.minecraft.sticky_piston": "piston gludiog",
  "block.minecraft.cobweb": "gwe pricopyn",
  "block.minecraft.grass": "glaswellt",
  "block.minecraft.fern": "rhedyn",
  "block.minecraft.dead_bush": "llwyn marw",
  "block.minecraft.seagrass": "morwellt",
  "block.minecraft.sea_pickle": "picl môr",
  "block.minecraft.piston": "piston",
  "block.minecraft.white_wool": "gwlân gwyn",
  "block.minecraft.orange_wool": "gwlân oren",
  "block.minecraft.magenta_wool": "gwlân majenta",
  "block.minecraft.light_blue_wool": "gwlân glas golau",
  "block.minecraft.yellow_wool": "gwlân melyn",
  "block.minecraft.lime_wool": "gwlân leim",
  "block.minecraft.pink_wool": "gwlân pinc",
  "block.minecraft.gray_wool": "gwlân llwyd",
  "block.minecraft.light_gray_wool": "gwlân llwyd golau",
  "block.minecraft.cyan_wool": "gwlân gwyrddlas",
  "block.minecraft.purple_wool": "gwlân porffor",
  "block.minecraft.blue_wool": "gwlân glas",
  "block.minecraft.brown_wool": "gwlân brown",
  "block.minecraft.green_wool": "gwlân gwyrdd",
  "block.minecraft.red_wool": "gwlân coch",
  "block.minecraft.black_wool": "gwlân du",
  "block.minecraft.dandelion": "dant y llew",
  "block.minecraft.poppy": "pabi",
  "block.minecraft.blue_orchid": "tegeirian glas",
  "block.minecraft.allium": "garllegyn",
  "block.minecraft.azure_bluet": "gwreiddrudd las",
  "block.minecraft.red_tulip": "tiwlip coch",
  "block.minecraft.orange_tulip": "tiwlip oren",
  "block.minecraft.white_tulip": "tiwlip gwyn",
  "block.minecraft.pink_tulip": "tiwlip pinc",
  "block.minecraft.oxeye_daisy": "llygad llo",
  "block.minecraft.cornflower": "penlas wen",
  "block.minecraft.lily_of_the_valley": "lili'r dyffrynnoedd",
  "block.minecraft.wither_rose": "rhosyn wither",
  "block.minecraft.brown_mushroom": "madarchen frown",
  "block.minecraft.red_mushroom": "madarchen goch",
  "block.minecraft.crimson_fungus": "ffwng rhuddgoch",
  "block.minecraft.warped_fungus": "ffwng annaearol",
  "block.minecraft.crimson_roots": "gwreiddiau rhuddgoch",
  "block.minecraft.warped_roots": "gwreiddiau annaearol",
  "block.minecraft.nether_sprouts": "egin nether",
  "block.minecraft.weeping_vines": "gwinwydd wylofus",
  "block.minecraft.twisting_vines": "gwinwydd dirdro",
  "block.minecraft.sugar_cane": "cansen siwgr",
  "block.minecraft.kelp": "gwymon",
  "block.minecraft.bamboo": "bambŵ",
  "block.minecraft.gold_block": "bloc aur",
  "block.minecraft.iron_block": "bloc haearn",
  "block.minecraft.oak_slab": "slab derw",
  "block.minecraft.spruce_slab": "slab pyrwydd",
  "block.minecraft.birch_slab": "slab bedw",
  "block.minecraft.jungle_slab": "slab jyngl",
  "block.minecraft.acacia_slab": "slab acesia",
  "block.minecraft.dark_oak_slab": "slab derw tywyll",
  "block.minecraft.crimson_slab": "slab rhuddgoch",
  "block.minecraft.warped_slab": "slab annaearol",
  "block.minecraft.stone_slab": "slab carreg",
  "block.minecraft.smooth_stone_slab": "slab carreg llyfn",
  "block.minecraft.sandstone_slab": "slab tywodfaen",
  "block.minecraft.cut_sandstone_slab": "slab tywodfaen toredig",
  "block.minecraft.petrified_oak_slab": "slab derw petraidd",
  "block.minecraft.cobblestone_slab": "slab crynion",
  "block.minecraft.brick_slab": "slab bricsen",
  "block.minecraft.stone_brick_slab": "slab bricsen carreg",
  "block.minecraft.nether_brick_slab": "slab bricsen nether",
  "block.minecraft.quartz_slab": "slab cwarts",
  "block.minecraft.red_sandstone_slab": "slab tywodfaen coch",
  "block.minecraft.cut_red_sandstone_slab": "slab tywodfaen coch toredig",
  "block.minecraft.purpur_slab": "slab purpur",
  "block.minecraft.prismarine_slab": "slab prismarin",
  "block.minecraft.prismarine_brick_slab": "slab bricsen prismarin",
  "block.minecraft.dark_prismarine_slab": "slab prismarin tywyll",
  "block.minecraft.smooth_quartz": "bloc cwartz llyfn",
  "block.minecraft.smooth_red_sandstone": "tywodfaen coch llyfn",
  "block.minecraft.smooth_sandstone": "tywodfaen llyfn",
  "block.minecraft.smooth_stone": "carreg llyfn",
  "block.minecraft.bricks": "briciau",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "silff lyfrau",
  "block.minecraft.mossy_cobblestone": "crynion mwsoglyd",
  "block.minecraft.obsidian": "llosgraig",
  "block.minecraft.torch": "tors",
  "block.minecraft.end_rod": "gwialen end",
  "block.minecraft.chorus_plant": "planhigyn corws",
  "block.minecraft.chorus_flower": "blodyn corws",
  "block.minecraft.purpur_block": "bloc purpur",
  "block.minecraft.purpur_pillar": "piler purpur",
  "block.minecraft.purpur_stairs": "grisiau purpur",
  "block.minecraft.spawner": "siliwr",
  "block.minecraft.oak_stairs": "grisiau derw",
  "block.minecraft.chest": "cist",
  "block.minecraft.diamond_ore": "mwyn diemwnt",
  "block.minecraft.diamond_block": "bloc diemwnt",
  "block.minecraft.crafting_table": "bwrdd crefft",
  "block.minecraft.farmland": "tir fferm",
  "block.minecraft.furnace": "ffwrnais",
  "block.minecraft.ladder": "ysgol",
  "block.minecraft.rail": "cledren",
  "block.minecraft.cobblestone_stairs": "grisiau carreg",
  "block.minecraft.lever": "lifer",
  "block.minecraft.stone_pressure_plate": "gwasglechen carreg",
  "block.minecraft.oak_pressure_plate": "gwasglechen derw",
  "block.minecraft.spruce_pressure_plate": "gwasglechen pyrwydd",
  "block.minecraft.birch_pressure_plate": "gwasglechen bedw",
  "block.minecraft.jungle_pressure_plate": "gwasglechen jyngl",
  "block.minecraft.acacia_pressure_plate": "gwasglechen acesia",
  "block.minecraft.dark_oak_pressure_plate": "gwasglechen derw tywyll",
  "block.minecraft.crimson_pressure_plate": "plât pwysedd rhuddgoch",
  "block.minecraft.warped_pressure_plate": "gwasglechen annaearol",
  "block.minecraft.polished_blackstone_pressure_plate": "plât pwysedd carregddu caboledig",
  "block.minecraft.redstone_ore": "mwyn redstone",
  "block.minecraft.redstone_torch": "tors redstone",
  "block.minecraft.snow": "eira",
  "block.minecraft.ice": "rhew",
  "block.minecraft.snow_block": "bloc eira",
  "block.minecraft.cactus": "cactws",
  "block.minecraft.clay": "clai",
  "block.minecraft.jukebox": "jiwcbocs",
  "block.minecraft.oak_fence": "ffens dderw",
  "block.minecraft.spruce_fence": "ffens byrwydd",
  "block.minecraft.birch_fence": "ffens fedw",
  "block.minecraft.jungle_fence": "ffens jyngl",
  "block.minecraft.acacia_fence": "ffens acesia",
  "block.minecraft.dark_oak_fence": "ffens dderw tywyll",
  "block.minecraft.crimson_fence": "ffens ruddgoch",
  "block.minecraft.warped_fence": "ffens annaearol",
  "block.minecraft.pumpkin": "pwmpen",
  "block.minecraft.carved_pumpkin": "pwmpen gerfiedig",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "tywod enaid",
  "block.minecraft.soul_soil": "pridd enaid",
  "block.minecraft.basalt": "pilergraig",
  "block.minecraft.polished_basalt": "pilergraig gloyw",
  "block.minecraft.soul_torch": "tors enaid",
  "block.minecraft.glowstone": "gloywgarreg",
  "block.minecraft.jack_o_lantern": "jac y lantarn",
  "block.minecraft.oak_trapdoor": "drws cudd derw",
  "block.minecraft.spruce_trapdoor": "drws cudd pyrwydd",
  "block.minecraft.birch_trapdoor": "drws cudd fedwen",
  "block.minecraft.jungle_trapdoor": "drws cudd jyngl",
  "block.minecraft.acacia_trapdoor": "drws cudd acesia",
  "block.minecraft.dark_oak_trapdoor": "drws cudd derw tywyll",
  "block.minecraft.crimson_trapdoor": "drws cudd rhuddgoch",
  "block.minecraft.warped_trapdoor": "drws cudd annaearol",
  "block.minecraft.infested_stone": "carreg pla",
  "block.minecraft.infested_cobblestone": "crynion pla",
  "block.minecraft.infested_stone_bricks": "briciau carreg pla",
  "block.minecraft.infested_mossy_stone_bricks": "briciau carreg mwsoglyd pla",
  "block.minecraft.infested_cracked_stone_bricks": "briciau carreg chwâl pla",
  "block.minecraft.infested_chiseled_stone_bricks": "briciau carreg nadd pla",
  "block.minecraft.stone_bricks": "briciau carreg",
  "block.minecraft.mossy_stone_bricks": "briciau carreg mwsoglyd",
  "block.minecraft.cracked_stone_bricks": "briciau carreg chwâl",
  "block.minecraft.chiseled_stone_bricks": "briciau carreg nadd",
  "block.minecraft.brown_mushroom_block": "bloc madarch brown",
  "block.minecraft.red_mushroom_block": "bloc madarch coch",
  "block.minecraft.mushroom_stem": "coesyn madarch",
  "block.minecraft.iron_bars": "bariau haearn",
  "block.minecraft.chain": "cadwyn",
  "block.minecraft.glass_pane": "paen gwydr",
  "block.minecraft.melon": "melon",
  "block.minecraft.vine": "gwinwydd",
  "block.minecraft.oak_fence_gate": "gât ffens dderw",
  "block.minecraft.spruce_fence_gate": "gât ffens byrwydd",
  "block.minecraft.birch_fence_gate": "gât ffens fedw",
  "block.minecraft.jungle_fence_gate": "gât ffens jyngl",
  "block.minecraft.acacia_fence_gate": "gât ffens acesia",
  "block.minecraft.dark_oak_fence_gate": "gât ffens dderw dwywll",
  "block.minecraft.crimson_fence_gate": "gât ffens ruddgoch",
  "block.minecraft.warped_fence_gate": "gât ffens annaearol",
  "block.minecraft.brick_stairs": "grisiau bricsen",
  "block.minecraft.stone_brick_stairs": "grisiau bricsen carreg",
  "block.minecraft.mycelium": "myseliwm",
  "block.minecraft.lily_pad": "paden lili",
  "block.minecraft.nether_bricks": "briciau nether",
  "block.minecraft.cracked_nether_bricks": "briciau nether chwâl",
  "block.minecraft.chiseled_nether_bricks": "briciau nether nadd",
  "block.minecraft.nether_brick_fence": "ffens fricsen nether",
  "block.minecraft.nether_brick_stairs": "grisiau bricsen nether",
  "block.minecraft.enchanting_table": "bwrdd hudoliaethu",
  "block.minecraft.end_portal_frame": "ffrâm borth end",
  "block.minecraft.end_stone": "carreg end",
  "block.minecraft.end_stone_bricks": "briciau carreg end",
  "block.minecraft.dragon_egg": "ŵy ddraig",
  "block.minecraft.redstone_lamp": "lamp redstone",
  "block.minecraft.sandstone_stairs": "grisiau tywodfaen",
  "block.minecraft.emerald_ore": "mwyn emrallt",
  "block.minecraft.ender_chest": "cist ender",
  "block.minecraft.tripwire_hook": "bachyn weiren faglu",
  "block.minecraft.emerald_block": "bloc emrallt",
  "block.minecraft.spruce_stairs": "grisiau pyrwydd",
  "block.minecraft.birch_stairs": "grisiau bedw",
  "block.minecraft.jungle_stairs": "grisiau jyngl",
  "block.minecraft.crimson_stairs": "grisiau rhuddgoch",
  "block.minecraft.warped_stairs": "grisiau annaearol",
  "block.minecraft.command_block": "bloc gorchymyn",
  "block.minecraft.beacon": "goleufa",
  "block.minecraft.cobblestone_wall": "wal crynion",
  "block.minecraft.mossy_cobblestone_wall": "wal crynion mwsoglyd",
  "block.minecraft.brick_wall": "wal friciau",
  "block.minecraft.prismarine_wall": "wal brismarin",
  "block.minecraft.red_sandstone_wall": "wal dywodfaen coch",
  "block.minecraft.mossy_stone_brick_wall": "wal friciau carreg mwsoglyd",
  "block.minecraft.granite_wall": "wal gwenithfaen",
  "block.minecraft.stone_brick_wall": "wal friciau carreg",
  "block.minecraft.nether_brick_wall": "wal friciau nether",
  "block.minecraft.andesite_wall": "wal andesit",
  "block.minecraft.red_nether_brick_wall": "wal friciau nether coch",
  "block.minecraft.sandstone_wall": "wal dywodfaen",
  "block.minecraft.end_stone_brick_wall": "wal friciau carreg end",
  "block.minecraft.diorite_wall": "wal diorit",
  "block.minecraft.blackstone_wall": "wal garregddu",
  "block.minecraft.polished_blackstone_wall": "wal garregddu caboledig",
  "block.minecraft.polished_blackstone_brick_wall": "wal friciau carregddu caboledig",
  "block.minecraft.stone_button": "botwm carreg",
  "block.minecraft.oak_button": "botwm derw",
  "block.minecraft.spruce_button": "botwm pyrwydd",
  "block.minecraft.birch_button": "botwm bedw",
  "block.minecraft.jungle_button": "botwm jyngl",
  "block.minecraft.acacia_button": "botwm acesia",
  "block.minecraft.dark_oak_button": "botwm derw tywyll",
  "block.minecraft.crimson_button": "botwm rhuddgoch",
  "block.minecraft.warped_button": "botwm annaearol",
  "block.minecraft.polished_blackstone_button": "botwm carregddu caboledig",
  "block.minecraft.anvil": "einion",
  "block.minecraft.chipped_anvil": "einion dolciog",
  "block.minecraft.damaged_anvil": "einion wedi'i ddifrodi",
  "block.minecraft.trapped_chest": "magl-gist",
  "block.minecraft.light_weighted_pressure_plate": "gwasglechen ysgafn",
  "block.minecraft.heavy_weighted_pressure_plate": "gwasglechen trwm",
  "block.minecraft.daylight_detector": "synhwyrydd golau dydd",
  "block.minecraft.redstone_block": "bloc redstone",
  "block.minecraft.nether_quartz_ore": "mwyn cwarts nether",
  "block.minecraft.hopper": "hopran",
  "block.minecraft.chiseled_quartz_block": "bloc cwarts nadd",
  "block.minecraft.quartz_block": "bloc cwarts",
  "block.minecraft.quartz_bricks": "briciau cwarts",
  "block.minecraft.quartz_pillar": "colofn cwarts",
  "block.minecraft.quartz_stairs": "grisiau cwarts",
  "block.minecraft.activator_rail": "cledren actifadydd",
  "block.minecraft.dropper": "gollyngwr",
  "block.minecraft.white_terracotta": "terracotta gwyn",
  "block.minecraft.orange_terracotta": "terracotta oren",
  "block.minecraft.magenta_terracotta": "terracotta majenta",
  "block.minecraft.light_blue_terracotta": "terracotta glas golau",
  "block.minecraft.yellow_terracotta": "terracotta melyn",
  "block.minecraft.lime_terracotta": "terracotta leim",
  "block.minecraft.pink_terracotta": "terracotta pinc",
  "block.minecraft.gray_terracotta": "terracotta llwydd",
  "block.minecraft.light_gray_terracotta": "terracotta llwydd golau",
  "block.minecraft.cyan_terracotta": "terracotta gwyrddlas",
  "block.minecraft.purple_terracotta": "terracotta porffor",
  "block.minecraft.blue_terracotta": "terracotta glas",
  "block.minecraft.brown_terracotta": "terracotta brown",
  "block.minecraft.green_terracotta": "terracotta gwyrdd",
  "block.minecraft.red_terracotta": "terracotta coch",
  "block.minecraft.black_terracotta": "terracotta du",
  "block.minecraft.barrier": "rhwystr",
  "block.minecraft.iron_trapdoor": "drws cudd haearn",
  "block.minecraft.hay_block": "bwrn gwair",
  "block.minecraft.white_carpet": "carped gwyn",
  "block.minecraft.orange_carpet": "carped oren",
  "block.minecraft.magenta_carpet": "carped majenta",
  "block.minecraft.light_blue_carpet": "carped glas golau",
  "block.minecraft.yellow_carpet": "carped melyn",
  "block.minecraft.lime_carpet": "carped leim",
  "block.minecraft.pink_carpet": "carped pinc",
  "block.minecraft.gray_carpet": "carped llwyd",
  "block.minecraft.light_gray_carpet": "carped llwyd golau",
  "block.minecraft.cyan_carpet": "carped gwyrddlas",
  "block.minecraft.purple_carpet": "carped porffor",
  "block.minecraft.blue_carpet": "carped glas",
  "block.minecraft.brown_carpet": "carped brown",
  "block.minecraft.green_carpet": "carped gwyrdd",
  "block.minecraft.red_carpet": "carped coch",
  "block.minecraft.black_carpet": "carped du",
  "block.minecraft.terracotta": "terracotta",
  "block.minecraft.coal_block": "bloc glo",
  "block.minecraft.packed_ice": "rhew cywasgedig",
  "block.minecraft.acacia_stairs": "grisiau acesia",
  "block.minecraft.dark_oak_stairs": "grisiau derw tywyll",
  "block.minecraft.slime_block": "bloc sleim",
  "block.minecraft.grass_path": "llwybr glaswellt",
  "block.minecraft.sunflower": "blodyn yr haul",
  "block.minecraft.lilac": "lelog",
  "block.minecraft.rose_bush": "llwyn rhosod",
  "block.minecraft.peony": "rhosyn y mynydd",
  "block.minecraft.tall_grass": "glaswellt hir",
  "block.minecraft.large_fern": "rhedyn fawr",
  "block.minecraft.white_stained_glass": "gwydr lliw gwyn",
  "block.minecraft.orange_stained_glass": "gwydr lliw oren",
  "block.minecraft.magenta_stained_glass": "gwydr lliw majenta",
  "block.minecraft.light_blue_stained_glass": "gwydr lliw glas golau",
  "block.minecraft.yellow_stained_glass": "gwydr lliw melyn",
  "block.minecraft.lime_stained_glass": "gwydr lliw leim",
  "block.minecraft.pink_stained_glass": "gwydr lliw pinc",
  "block.minecraft.gray_stained_glass": "gwydr lliw llwyd",
  "block.minecraft.light_gray_stained_glass": "gwydr lliw llwyd golau",
  "block.minecraft.cyan_stained_glass": "gwydr lliw gwyrddlas",
  "block.minecraft.purple_stained_glass": "gwydr lliw porffor",
  "block.minecraft.blue_stained_glass": "gwydr lliw glas",
  "block.minecraft.brown_stained_glass": "gwydr lliw brown",
  "block.minecraft.green_stained_glass": "gwydr lliw gwyrdd",
  "block.minecraft.red_stained_glass": "gwydr lliw coch",
  "block.minecraft.black_stained_glass": "gwydr lliw du",
  "block.minecraft.white_stained_glass_pane": "paen gwydr lliw gwyn",
  "block.minecraft.orange_stained_glass_pane": "paen gwydr lliw oren",
  "block.minecraft.magenta_stained_glass_pane": "paen gwydr lliw majenta",
  "block.minecraft.light_blue_stained_glass_pane": "paen gwydr lliw glas golau",
  "block.minecraft.yellow_stained_glass_pane": "paen gwydr lliw melyn",
  "block.minecraft.lime_stained_glass_pane": "paen gwydr lliw leim",
  "block.minecraft.pink_stained_glass_pane": "paen gwydr lliw pinc",
  "block.minecraft.gray_stained_glass_pane": "paen gwydr lliw llwyd",
  "block.minecraft.light_gray_stained_glass_pane": "paen gwydr lliw llwyd golau",
  "block.minecraft.cyan_stained_glass_pane": "paen gwydr lliw gwyrddlas",
  "block.minecraft.purple_stained_glass_pane": "paen gwydr lliw porffor",
  "block.minecraft.blue_stained_glass_pane": "paen gwydr lliw glas",
  "block.minecraft.brown_stained_glass_pane": "paen gwydr lliw brown",
  "block.minecraft.green_stained_glass_pane": "paen gwydr lliw gwyrdd",
  "block.minecraft.red_stained_glass_pane": "paen gwydr lliw coch",
  "block.minecraft.black_stained_glass_pane": "paen gwydr lliw du",
  "block.minecraft.prismarine": "prismarin",
  "block.minecraft.prismarine_bricks": "briciau prismarin",
  "block.minecraft.dark_prismarine": "prismarin tywyll",
  "block.minecraft.prismarine_stairs": "grisiau prismarin",
  "block.minecraft.prismarine_brick_stairs": "grisiau bricsen prismarin",
  "block.minecraft.dark_prismarine_stairs": "grisiau prismarin tywyll",
  "block.minecraft.sea_lantern": "llusern fôr",
  "block.minecraft.red_sandstone": "tywodfaen coch",
  "block.minecraft.chiseled_red_sandstone": "tywodfaen nadd coch",
  "block.minecraft.cut_red_sandstone": "tywodfaen coch toredig",
  "block.minecraft.red_sandstone_stairs": "grisiau tywodfaen coch",
  "block.minecraft.repeating_command_block": "bloc gorchymyn ailadroddol",
  "block.minecraft.chain_command_block": "bloc gorchymyn cadwynol",
  "block.minecraft.magma_block": "bloc magma",
  "block.minecraft.nether_wart_block": "bloc chwyn nether",
  "block.minecraft.warped_wart_block": "bloc chwyn annaearol",
  "block.minecraft.red_nether_bricks": "briciau nether coch",
  "block.minecraft.bone_block": "bloc asgwrn",
  "block.minecraft.structure_void": "gwagle strwythur",
  "block.minecraft.observer": "gwyliwr",
  "block.minecraft.shulker_box": "blwch shulker",
  "block.minecraft.white_shulker_box": "blwch shulker gwyn",
  "block.minecraft.orange_shulker_box": "blwch shulker oren",
  "block.minecraft.magenta_shulker_box": "blwch shulker majenta",
  "block.minecraft.light_blue_shulker_box": "blwch shulker glas golau",
  "block.minecraft.yellow_shulker_box": "blwch shulker melyn",
  "block.minecraft.lime_shulker_box": "blwch shulker leim",
  "block.minecraft.pink_shulker_box": "blwch shulker pinc",
  "block.minecraft.gray_shulker_box": "blwch shulker llwyd",
  "block.minecraft.light_gray_shulker_box": "blwch shulker llwyd golau",
  "block.minecraft.cyan_shulker_box": "blwch shulker gwyrddlas",
  "block.minecraft.purple_shulker_box": "blwch shulker porffor",
  "block.minecraft.blue_shulker_box": "blwch shulker glas",
  "block.minecraft.brown_shulker_box": "blwch shulker brown",
  "block.minecraft.green_shulker_box": "blwch shulker gwyrdd",
  "block.minecraft.red_shulker_box": "blwch shulker coch",
  "block.minecraft.black_shulker_box": "blwch shulker du",
  "block.minecraft.white_glazed_terracotta": "terracotta gwyn gwydrog",
  "block.minecraft.orange_glazed_terracotta": "terracotta oren gwydrog",
  "block.minecraft.magenta_glazed_terracotta": "terracotta majenta gwydrog",
  "block.minecraft.light_blue_glazed_terracotta": "terracotta glas golau gwydrog",
  "block.minecraft.yellow_glazed_terracotta": "terracotta melyn gwydrog",
  "block.minecraft.lime_glazed_terracotta": "terracotta leim gwydrog",
  "block.minecraft.pink_glazed_terracotta": "terracotta pinc gwydrog",
  "block.minecraft.gray_glazed_terracotta": "terracotta llwyd gwydrog",
  "block.minecraft.light_gray_glazed_terracotta": "terracotta llwyd golau gwydrog",
  "block.minecraft.cyan_glazed_terracotta": "terracotta gwyrddlas gwydrog",
  "block.minecraft.purple_glazed_terracotta": "terracotta porffor gwydrog",
  "block.minecraft.blue_glazed_terracotta": "terracotta glas gwydrog",
  "block.minecraft.brown_glazed_terracotta": "terracotta brown gwydrog",
  "block.minecraft.green_glazed_terracotta": "terracotta gwyrdd gwydrog",
  "block.minecraft.red_glazed_terracotta": "terracotta coch gwydrog",
  "block.minecraft.black_glazed_terracotta": "terracotta du gwydrog",
  "block.minecraft.white_concrete": "concrit gwyn",
  "block.minecraft.orange_concrete": "concrit oren",
  "block.minecraft.magenta_concrete": "concrit majenta",
  "block.minecraft.light_blue_concrete": "concrit glas golau",
  "block.minecraft.yellow_concrete": "concrit melyn",
  "block.minecraft.lime_concrete": "concrit leim",
  "block.minecraft.pink_concrete": "concrit pinc",
  "block.minecraft.gray_concrete": "concrit llwyd",
  "block.minecraft.light_gray_concrete": "concrit llwyd golau",
  "block.minecraft.cyan_concrete": "concrit gwyrddlas",
  "block.minecraft.purple_concrete": "concrit porffor",
  "block.minecraft.blue_concrete": "concrit glas",
  "block.minecraft.brown_concrete": "concrit brown",
  "block.minecraft.green_concrete": "concrit gwyrdd",
  "block.minecraft.red_concrete": "concrit coch",
  "block.minecraft.black_concrete": "concrit du",
  "block.minecraft.white_concrete_powder": "powdr concrit gwyn",
  "block.minecraft.orange_concrete_powder": "powdr concrit oren",
  "block.minecraft.magenta_concrete_powder": "powdr concrit majenta",
  "block.minecraft.light_blue_concrete_powder": "powdr concrit glas golau",
  "block.minecraft.yellow_concrete_powder": "powdr concrit melyn",
  "block.minecraft.lime_concrete_powder": "powdr concrit leim",
  "block.minecraft.pink_concrete_powder": "powdr concrit pinc",
  "block.minecraft.gray_concrete_powder": "powdr concrit llwyd",
  "block.minecraft.light_gray_concrete_powder": "powdr concrit llwyd golau",
  "block.minecraft.cyan_concrete_powder": "powdr concrit gwyrddlas",
  "block.minecraft.purple_concrete_powder": "powdr concrit porffor",
  "block.minecraft.blue_concrete_powder": "powdr concrit glas",
  "block.minecraft.brown_concrete_powder": "powdr concrit brown",
  "block.minecraft.green_concrete_powder": "powdr concrit gwyrdd",
  "block.minecraft.red_concrete_powder": "powdr concrit coch",
  "block.minecraft.black_concrete_powder": "powdr concrit du",
  "block.minecraft.turtle_egg": "wy crwban",
  "block.minecraft.dead_tube_coral_block": "bloc cwrel piben marw",
  "block.minecraft.dead_brain_coral_block": "bloc cwrel ymennydd wedi marw",
  "block.minecraft.dead_bubble_coral_block": "bloc cwrel brith marw",
  "block.minecraft.dead_fire_coral_block": "bloc cwrel tân marw",
  "block.minecraft.dead_horn_coral_block": "bloc cwrel corn marw",
  "block.minecraft.tube_coral_block": "bloc cwrel piben",
  "block.minecraft.brain_coral_block": "bloc cwrel ymenydd",
  "block.minecraft.bubble_coral_block": "bloc cwrel brith",
  "block.minecraft.fire_coral_block": "bloc cwrel tân",
  "block.minecraft.horn_coral_block": "bloc cwrel corn",
  "block.minecraft.tube_coral": "cwrel piben",
  "block.minecraft.brain_coral": "cwrel ymenydd",
  "block.minecraft.bubble_coral": "cwrel brith",
  "block.minecraft.fire_coral": "cwrel tân",
  "block.minecraft.horn_coral": "cwrel corn",
  "block.minecraft.dead_brain_coral": "cwrel ymenydd wedi marw",
  "block.minecraft.dead_bubble_coral": "cwrel brith marw",
  "block.minecraft.dead_fire_coral": "cwrel tân marw",
  "block.minecraft.dead_horn_coral": "cwrel corn marw",
  "block.minecraft.dead_tube_coral": "cwrel piben marw",
  "block.minecraft.tube_coral_fan": "ffan cwrel piben",
  "block.minecraft.brain_coral_fan": "ffan cwrel ymenydd",
  "block.minecraft.bubble_coral_fan": "ffan cwrel brith",
  "block.minecraft.fire_coral_fan": "ffan cwrel tân",
  "block.minecraft.horn_coral_fan": "ffan gwrel corn",
  "block.minecraft.dead_tube_coral_fan": "ffan gwrel piben marw",
  "block.minecraft.dead_brain_coral_fan": "ffan cwrel ymennydd wedi marw",
  "block.minecraft.dead_bubble_coral_fan": "ffan gwrel brith marw",
  "block.minecraft.dead_fire_coral_fan": "ffan gwrel tân marw",
  "block.minecraft.dead_horn_coral_fan": "ffan gwrel corn marw",
  "block.minecraft.blue_ice": "rhew glas",
  "block.minecraft.conduit": "cwndid",
  "block.minecraft.polished_granite_stairs": "grisiau gwenithfaen caboledig",
  "block.minecraft.smooth_red_sandstone_stairs": "grisiau tywodfaen coch llyfn",
  "block.minecraft.mossy_stone_brick_stairs": "grisiau bricsen carreg mwsoglyd",
  "block.minecraft.polished_diorite_stairs": "grisiau diorit caboledig",
  "block.minecraft.mossy_cobblestone_stairs": "grisiau crynion mwsoglyd",
  "block.minecraft.end_stone_brick_stairs": "grisiau bricsen carreg end",
  "block.minecraft.stone_stairs": "grisiau carreg",
  "block.minecraft.smooth_sandstone_stairs": "grisiau tywodfaen llyfn",
  "block.minecraft.smooth_quartz_stairs": "grisiau cwarts llyfn",
  "block.minecraft.granite_stairs": "grisiau gwenithfaen",
  "block.minecraft.andesite_stairs": "grisiau andesit",
  "block.minecraft.red_nether_brick_stairs": "grisiau bricsen nether coch",
  "block.minecraft.polished_andesite_stairs": "grisiau andesit caboledig",
  "block.minecraft.diorite_stairs": "grisiau diorit",
  "block.minecraft.polished_granite_slab": "slab gwenithfaen caboledig",
  "block.minecraft.smooth_red_sandstone_slab": "slab tywodfaen coch llyfn",
  "block.minecraft.mossy_stone_brick_slab": "slab bricsen carreg mwsoglyd",
  "block.minecraft.polished_diorite_slab": "slab diorit caboledig",
  "block.minecraft.mossy_cobblestone_slab": "slab crynion mwsoglyd",
  "block.minecraft.end_stone_brick_slab": "slab bricsen carreg end",
  "block.minecraft.smooth_sandstone_slab": "slab tywodfaen llyfn",
  "block.minecraft.smooth_quartz_slab": "slab cwarts llyfn",
  "block.minecraft.granite_slab": "slab gwenithfaen",
  "block.minecraft.andesite_slab": "slab andesit",
  "block.minecraft.red_nether_brick_slab": "slab bricsen nether coch",
  "block.minecraft.polished_andesite_slab": "slab andesit caboledig",
  "block.minecraft.diorite_slab": "slab diorit",
  "block.minecraft.scaffolding": "sgaffaldiau",
  "block.minecraft.iron_door": "drws haearn",
  "block.minecraft.oak_door": "drws derw",
  "block.minecraft.spruce_door": "drws pyrwydd",
  "block.minecraft.birch_door": "drws bedw",
  "block.minecraft.jungle_door": "drws jyngl",
  "block.minecraft.acacia_door": "drws acesia",
  "block.minecraft.dark_oak_door": "drws derw tywyll",
  "block.minecraft.crimson_door": "drws rhuddgoch",
  "block.minecraft.warped_door": "drws annaearol",
  "block.minecraft.repeater": "ailadroddwr redstone",
  "block.minecraft.comparator": "cymharydd redstone",
  "block.minecraft.structure_block": "bloc adeileddol",
  "block.minecraft.jigsaw": "bloc jig-sô",
  "item.minecraft.turtle_helmet": "cragen crwban□□pan ar y pen:□+2 arfwisg",
  "item.minecraft.scute": "sgwtela",
  "item.minecraft.iron_shovel": "rhaw haearn□□pan yn y prif law:□+3.5 difrod ymosod□-3 cyflymder ymosod",
  "item.minecraft.iron_pickaxe": "caib haearn□□pan yn y prif law:□+3 difrod ymosod□-2.8 cyflymder ymosod",
  "item.minecraft.iron_axe": "bwyell haearn□□pan yn y prif law:□+8 difrod ymosod□-3.1 cyflymder ymosod",
  "item.minecraft.flint_and_steel": "fflint a dur",
  "item.minecraft.apple": "afal",
  "item.minecraft.bow": "bwa",
  "item.minecraft.arrow": "saeth",
  "item.minecraft.coal": "glo",
  "item.minecraft.charcoal": "golosg",
  "item.minecraft.diamond": "diemwnt",
  "item.minecraft.iron_ingot": "bar haearn",
  "item.minecraft.gold_ingot": "bar aur",
  "item.minecraft.netherite_ingot": "bar netherit",
  "item.minecraft.netherite_scrap": "sgrap netherit",
  "item.minecraft.iron_sword": "cleddyf haearn□□pan yn y prif law:□+5 difrod ymosod□-2.4 cyflymder ymosod",
  "item.minecraft.wooden_sword": "cleddyf pren□□pan yn y prif law:□+3 difrod ymosod□-2.4 cyflymder ymosod",
  "item.minecraft.wooden_shovel": "rhaw pren□□pan yn y prif law:□+1.5 difrod ymosod□-3 cyflymder ymosod",
  "item.minecraft.wooden_pickaxe": "caib pren□□pan yn y prif law:□+1 difrod ymosod□-2.8 cyflymder ymosod",
  "item.minecraft.wooden_axe": "bwyell pren□□pan yn y prif law:□+6 difrod ymosod□-3.2 cyflymder ymosod",
  "item.minecraft.stone_sword": "cleddyf carreg□□pan yn y prif law:□+4 difrod ymosod□-2.4 cyflymder ymosod",
  "item.minecraft.stone_shovel": "rhaw carreg□□pan yn y prif law:□+2.5 difrod ymosod□-3 cyflymder ymosod",
  "item.minecraft.stone_pickaxe": "caib carreg□□pan yn y prif law:□+2 difrod ymosod□-2.8 cyflymder ymosod",
  "item.minecraft.stone_axe": "bwyell carreg□□pan yn y prif law:□+8 difrod ymosod□-3.2 cyflymder ymosod",
  "item.minecraft.diamond_sword": "cleddyf diemwnt□□pan yn y prif law:□+6 difrod ymosod□-2.4 cyflymder ymosod",
  "item.minecraft.diamond_shovel": "rhaw diemwnt□□pan yn y prif law:□+4.5 difrod ymosod□-3 cyflymder ymosod",
  "item.minecraft.diamond_pickaxe": "caib diemwnt□□pan yn y prif law:□+4 difrod ymosod□-2.8 cyflymder ymosod",
  "item.minecraft.diamond_axe": "bwyell diemwnt□□pan yn y prif law:□+8 difrod ymosod□-3 cyflymder ymosod",
  "item.minecraft.stick": "ffon",
  "item.minecraft.bowl": "powlen",
  "item.minecraft.mushroom_stew": "cawl madarch",
  "item.minecraft.golden_sword": "cleddyf aur□□pan yn y prif law:□+3 difrod ymosod□-2.4 cyflymder ymosod",
  "item.minecraft.golden_shovel": "rhaw aur□□pan yn y prif law:□+1.5 difrod ymosod□-3 cyflymder ymosod",
  "item.minecraft.golden_pickaxe": "caib aur□□pan yn y prif law:□+1 difrod ymosod□-2.8 cyflymder ymosod",
  "item.minecraft.golden_axe": "bwyell aur□□pan yn y prif law:□+6 difrod ymosod□-3 cyflymder ymosod",
  "item.minecraft.netherite_sword": "cleddyf netherit□□pan yn y prif law:□+7 difrod ymosod□-2.4 cyflymder ymosod",
  "item.minecraft.netherite_shovel": "rhaw netherit□□pan yn y prif law:□+5.5 difrod ymosod□-3 cyflymder ymosod",
  "item.minecraft.netherite_pickaxe": "caib netherit□□pan yn y prif law:□+5 difrod ymosod□-2.8 cyflymder ymosod",
  "item.minecraft.netherite_axe": "bwyell netherit□□pan yn y prif law:□+9 difrod ymosod□-3 cyflymder ymosod",
  "item.minecraft.string": "llinyn",
  "item.minecraft.feather": "pluen",
  "item.minecraft.gunpowder": "powdr gwn",
  "item.minecraft.wooden_hoe": "hof pren□□pan yn y prif law:□-3 cyflymder ymosod",
  "item.minecraft.stone_hoe": "hof carreg□□pan yn y prif law:□-2 cyflymder ymosod",
  "item.minecraft.iron_hoe": "hof haearn□□pan yn y prif law:□-1 cyflymder ymosod",
  "item.minecraft.diamond_hoe": "hof diemwnt□□pan yn y prif law:",
  "item.minecraft.golden_hoe": "hof aur□□pan yn y prif law:□-3 cyflymder ymosod",
  "item.minecraft.netherite_hoe": "hof netherit□□pan yn y prif law:",
  "item.minecraft.wheat_seeds": "hadau gwenith",
  "item.minecraft.wheat": "gwenith",
  "item.minecraft.bread": "bara",
  "item.minecraft.leather_helmet": "het lledr□□pan ar y pen:□+1 arfwisg",
  "item.minecraft.leather_chestplate": "tiwnig lledr□□pan ar y corff:□+3 arfwisg",
  "item.minecraft.leather_leggings": "trowser lledr□□pan ar y coesau:□+2 arfwisg",
  "item.minecraft.leather_boots": "esgidiau lledr□□pan ar y traed:□+1 arfwisg",
  "item.minecraft.chainmail_helmet": "helmed maelwisg□□pan ar y pen:□+2 arfwisg",
  "item.minecraft.chainmail_chestplate": "dwyfronneg maelwisg□□pan ar y corff:□+5 arfwisg",
  "item.minecraft.chainmail_leggings": "legins maelwisg□□pan ar y coesau:□+4 arfwisg",
  "item.minecraft.chainmail_boots": "esgidiau maelwisg□□pan ar y traed:□+1 arfwisg",
  "item.minecraft.iron_helmet": "helmed haearn□□pan ar y pen:□+2 arfwisg",
  "item.minecraft.iron_chestplate": "dwyfronneg haearn□□pan ar y corff:□+6 arfwisg",
  "item.minecraft.iron_leggings": "legins haearn□□pan ar y coesau:□+5 arfwisg",
  "item.minecraft.iron_boots": "esgidiau haearn□□pan ar y traed:□+2 arfwisg",
  "item.minecraft.diamond_helmet": "helmed diemwnt□□pan ar y pen:□+3 arfwisg□+2 gwydnwch arfwisg",
  "item.minecraft.diamond_chestplate": "dwyfronneg diemwnt□□pan ar y corff:□+8 arfwisg□+2 gwydnwch arfwisg",
  "item.minecraft.diamond_leggings": "legins diemwnt□□pan ar y coesau:□+6 arfwisg□+2 gwydnwch arfwisg",
  "item.minecraft.diamond_boots": "esgidiau diemwnt□□pan ar y traed:□+3 arfwisg□+2 gwydnwch arfwisg",
  "item.minecraft.golden_helmet": "helmed aur□□pan ar y pen:□+2 arfwisg",
  "item.minecraft.golden_chestplate": "dwyfronneg aur□□pan ar y corff:□+5 arfwisg",
  "item.minecraft.golden_leggings": "legins aur□□pan ar y coesau:□+3 arfwisg",
  "item.minecraft.golden_boots": "esgidiau aur□□pan ar y traed:□+1 arfwisg",
  "item.minecraft.netherite_helmet": "helmed netherit□□pan ar y pen:□+3 arfwisg□+3 gwydnwch arfwisg□+1 gwrthsafiad curo 'nol",
  "item.minecraft.netherite_chestplate": "dwyfronneg netherit□□pan ar y corff:□+8 arfwisg□+3 gwydnwch arfwisg□+1 gwrthsafiad curo 'nol",
  "item.minecraft.netherite_leggings": "legins netherit□□pan ar y coesau:□+6 arfwisg□+3 gwydnwch arfwisg□+1 gwrthsafiad curo 'nol",
  "item.minecraft.netherite_boots": "esgidiau netherit□□pan ar y traed:□+3 arfwisg□+3 gwydnwch arfwisg□+1 gwrthsafiad curo 'nol",
  "item.minecraft.flint": "fflint",
  "item.minecraft.porkchop": "porc amrwd",
  "item.minecraft.cooked_porkchop": "porc rhost",
  "item.minecraft.painting": "llun",
  "item.minecraft.golden_apple": "afal euraid",
  "item.minecraft.enchanted_golden_apple": "afal euraid hudolus",
  "block.minecraft.oak_sign": "arwydd derw",
  "block.minecraft.spruce_sign": "arwydd pyrwydd",
  "block.minecraft.birch_sign": "arwydd bedw",
  "block.minecraft.jungle_sign": "arwydd jyngl",
  "block.minecraft.acacia_sign": "arwydd acesia",
  "block.minecraft.dark_oak_sign": "arwydd derw tywyll",
  "block.minecraft.crimson_sign": "arwydd rhuddgoch",
  "block.minecraft.warped_sign": "arwydd annaearol",
  "item.minecraft.bucket": "bwced",
  "item.minecraft.water_bucket": "bwced dŵr",
  "item.minecraft.lava_bucket": "bwced lafa",
  "item.minecraft.minecart": "cart pwll",
  "item.minecraft.saddle": "cyfrwy",
  "item.minecraft.redstone": "llwch redstone",
  "item.minecraft.snowball": "pelen eira",
  "item.minecraft.oak_boat": "cwch derw",
  "item.minecraft.leather": "lledr",
  "item.minecraft.milk_bucket": "bwced llaeth",
  "item.minecraft.pufferfish_bucket": "bwced o chwyddbysgod",
  "item.minecraft.salmon_bucket": "bwced o eog",
  "item.minecraft.cod_bucket": "bwced o benfrasiaid",
  "item.minecraft.tropical_fish_bucket": "bwced o bysgod trofannol",
  "item.minecraft.brick": "bricsen",
  "item.minecraft.clay_ball": "pelen clai",
  "block.minecraft.dried_kelp_block": "bloc gwymon sych",
  "item.minecraft.paper": "papur",
  "item.minecraft.book": "llyfr",
  "item.minecraft.slime_ball": "pelen sleim",
  "item.minecraft.chest_minecart": "cart pwll gyda chist",
  "item.minecraft.furnace_minecart": "cart pwll gyda ffwrnais",
  "item.minecraft.egg": "wy",
  "item.minecraft.compass": "cwmpawd",
  "item.minecraft.fishing_rod": "gwialen pysgota",
  "item.minecraft.clock": "cloc",
  "item.minecraft.glowstone_dust": "llwch gloywgarreg",
  "item.minecraft.cod": "penfras amrwd",
  "item.minecraft.salmon": "eog amrwd",
  "item.minecraft.tropical_fish": "pysgodyn trofannol",
  "item.minecraft.pufferfish": "chwyddbysgodyn",
  "item.minecraft.cooked_cod": "penfras rhost",
  "item.minecraft.cooked_salmon": "eog rhost",
  "item.minecraft.ink_sac": "coden inc",
  "item.minecraft.red_dye": "llifyn coch",
  "item.minecraft.green_dye": "llifyn gwyrdd",
  "item.minecraft.cocoa_beans": "ffa coco",
  "item.minecraft.lapis_lazuli": "lapis-laswli",
  "item.minecraft.purple_dye": "llifyn porffor",
  "item.minecraft.cyan_dye": "llifyn gwyrddlas",
  "item.minecraft.light_gray_dye": "llifyn llwyd golau",
  "item.minecraft.gray_dye": "llifyn llwyd",
  "item.minecraft.pink_dye": "llifyn pinc",
  "item.minecraft.lime_dye": "llifyn leim",
  "item.minecraft.yellow_dye": "llifyn melyn",
  "item.minecraft.light_blue_dye": "llifyn glas golau",
  "item.minecraft.magenta_dye": "llifyn majenta",
  "item.minecraft.orange_dye": "llifyn oren",
  "item.minecraft.bone_meal": "blawd esgyrn",
  "item.minecraft.blue_dye": "llifyn glas",
  "item.minecraft.brown_dye": "llifyn brown",
  "item.minecraft.black_dye": "llifyn du",
  "item.minecraft.white_dye": "llifyn gwyn",
  "item.minecraft.bone": "asgwrn",
  "item.minecraft.sugar": "siwgr",
  "block.minecraft.cake": "teisen",
  "block.minecraft.white_bed": "gwely gwyn",
  "block.minecraft.orange_bed": "gwely oren",
  "block.minecraft.magenta_bed": "gwely majenta",
  "block.minecraft.light_blue_bed": "gwely glas golau",
  "block.minecraft.yellow_bed": "gwely melyn",
  "block.minecraft.lime_bed": "gwely leim",
  "block.minecraft.pink_bed": "gwely pinc",
  "block.minecraft.gray_bed": "gwely llwyd",
  "block.minecraft.light_gray_bed": "gwely llwyd golau",
  "block.minecraft.cyan_bed": "gwely gwyrddlas",
  "block.minecraft.purple_bed": "gwely porffor",
  "block.minecraft.blue_bed": "gwely glas",
  "block.minecraft.brown_bed": "gwely brown",
  "block.minecraft.green_bed": "gwely gwyrdd",
  "block.minecraft.red_bed": "gwely coch",
  "block.minecraft.black_bed": "gwely du",
  "item.minecraft.cookie": "bisgeden",
  "item.minecraft.filled_map": "map□#0",
  "item.minecraft.shears": "gwellau",
  "item.minecraft.melon_slice": "tafell melon",
  "item.minecraft.dried_kelp": "gwymon sych",
  "item.minecraft.pumpkin_seeds": "hadau pwmpen",
  "item.minecraft.melon_seeds": "hadau melon",
  "item.minecraft.beef": "cig eidion amrwd",
  "item.minecraft.cooked_beef": "stecen",
  "item.minecraft.chicken": "cyw iar amrwd",
  "item.minecraft.cooked_chicken": "cyw iar rhost",
  "item.minecraft.rotten_flesh": "cnawd pwdr",
  "item.minecraft.ender_pearl": "perl ender",
  "item.minecraft.blaze_rod": "gwialen tânfwystfil",
  "item.minecraft.ghast_tear": "deigryn ghast",
  "item.minecraft.gold_nugget": "clap aur",
  "item.minecraft.nether_wart": "chwyn nether",
  "item.minecraft.potion": "diod anghrefftadwy□dim effeithiau",
  "item.minecraft.glass_bottle": "potel gwydr",
  "item.minecraft.spider_eye": "llygaid pricopyn",
  "item.minecraft.fermented_spider_eye": "llygaid pricopyn wedi eplesu",
  "item.minecraft.blaze_powder": "llwch tânfwystfil",
  "item.minecraft.magma_cream": "hufen magma",
  "block.minecraft.brewing_stand": "safle bragu",
  "block.minecraft.cauldron": "crochan",
  "item.minecraft.ender_eye": "llygad ender",
  "item.minecraft.glistering_melon_slice": "tafell melon euraid",
  "item.minecraft.bat_spawn_egg": "wy geni ystlum",
  "item.minecraft.bee_spawn_egg": "ŵy geni gwenyn",
  "item.minecraft.blaze_spawn_egg": "wy geni tanfwystfil",
  "item.minecraft.cat_spawn_egg": "wy geni cath",
  "item.minecraft.cave_spider_spawn_egg": "wy geni pry copyn ogof",
  "item.minecraft.chicken_spawn_egg": "wy geni iar",
  "item.minecraft.cod_spawn_egg": "wy geni penfras",
  "item.minecraft.cow_spawn_egg": "wy geni buwch",
  "item.minecraft.creeper_spawn_egg": "wy geni cripyr",
  "item.minecraft.dolphin_spawn_egg": "wy geni dolffin",
  "item.minecraft.donkey_spawn_egg": "wy geni asyn",
  "item.minecraft.drowned_spawn_egg": "wy geni boddedig",
  "item.minecraft.elder_guardian_spawn_egg": "wy geni gwarchodwr hyn",
  "item.minecraft.enderman_spawn_egg": "wy geni enderman",
  "item.minecraft.endermite_spawn_egg": "wy geni endermite",
  "item.minecraft.evoker_spawn_egg": "wy geni consuriwr",
  "item.minecraft.fox_spawn_egg": "wy geni llwynog",
  "item.minecraft.ghast_spawn_egg": "wy geni ghast",
  "item.minecraft.guardian_spawn_egg": "wy geni gwarchodwr",
  "item.minecraft.hoglin_spawn_egg": "ŵy geni hoglin",
  "item.minecraft.horse_spawn_egg": "wy geni ceffyl",
  "item.minecraft.husk_spawn_egg": "wy geni cibyn",
  "item.minecraft.llama_spawn_egg": "wy gemi lama",
  "item.minecraft.magma_cube_spawn_egg": "wy geni ciwb magma",
  "item.minecraft.mooshroom_spawn_egg": "wy geni mooshroom",
  "item.minecraft.mule_spawn_egg": "wy geni mul",
  "item.minecraft.ocelot_spawn_egg": "wy geni oselot",
  "item.minecraft.panda_spawn_egg": "wy geni panda",
  "item.minecraft.parrot_spawn_egg": "wy geni parot",
  "item.minecraft.phantom_spawn_egg": "wy geni ffantom",
  "item.minecraft.pig_spawn_egg": "wy geni mochyn",
  "item.minecraft.piglin_spawn_egg": "wy geni piglin",
  "item.minecraft.pillager_spawn_egg": "wy geni ysbeiliwr",
  "item.minecraft.polar_bear_spawn_egg": "wy geni arth wen",
  "item.minecraft.pufferfish_spawn_egg": "wy geni chwyddbysgodyn",
  "item.minecraft.rabbit_spawn_egg": "wy geni cwningen",
  "item.minecraft.ravager_spawn_egg": "wy geni difrodwr",
  "item.minecraft.salmon_spawn_egg": "wy geni eog",
  "item.minecraft.sheep_spawn_egg": "wy geni dafad",
  "item.minecraft.shulker_spawn_egg": "wy geni shulker",
  "item.minecraft.silverfish_spawn_egg": "wy geni pryf arian",
  "item.minecraft.skeleton_spawn_egg": "wy geni sgerbwd",
  "item.minecraft.skeleton_horse_spawn_egg": "wy geni ceffyl sgerbwd",
  "item.minecraft.slime_spawn_egg": "wy geni sleim",
  "item.minecraft.spider_spawn_egg": "wy geni pry copyn",
  "item.minecraft.squid_spawn_egg": "wy geni ystifflog",
  "item.minecraft.stray_spawn_egg": "wy geni crwydryn",
  "item.minecraft.strider_spawn_egg": "ŵy geni brasgamwr",
  "item.minecraft.trader_llama_spawn_egg": "wy geni lama masnachwr",
  "item.minecraft.tropical_fish_spawn_egg": "wy geni pysgodyn trofannol",
  "item.minecraft.turtle_spawn_egg": "wy geni crwban y môr",
  "item.minecraft.vex_spawn_egg": "wy geni cythral",
  "item.minecraft.villager_spawn_egg": "wy geni pentrefwr",
  "item.minecraft.vindicator_spawn_egg": "wy geni gwas",
  "item.minecraft.wandering_trader_spawn_egg": "wy geni masnachwr crwydrol",
  "item.minecraft.witch_spawn_egg": "wy geni gwrach",
  "item.minecraft.wither_skeleton_spawn_egg": "wy geni sgerbwd wither",
  "item.minecraft.wolf_spawn_egg": "wy geni blaidd",
  "item.minecraft.zoglin_spawn_egg": "wy geni soglin",
  "item.minecraft.zombie_spawn_egg": "wy geni sombi",
  "item.minecraft.zombie_horse_spawn_egg": "wy geni ceffyl sombi",
  "item.minecraft.zombie_villager_spawn_egg": "wy geni pentrefwr sombi",
  "item.minecraft.zombified_piglin_spawn_egg": "wy geni piglin sombi",
  "item.minecraft.experience_bottle": "potel hudoliaeth",
  "item.minecraft.fire_charge": "pelen dân",
  "item.minecraft.writable_book": "llyfr a chwilsen",
  "item.minecraft.written_book": "llyfr a ysgrifennwyd",
  "item.minecraft.emerald": "emrallt",
  "item.minecraft.item_frame": "ffrâm eitem",
  "block.minecraft.flower_pot": "pot blodau",
  "item.minecraft.carrot": "moronen",
  "item.minecraft.potato": "taten",
  "item.minecraft.baked_potato": "taten pob",
  "item.minecraft.poisonous_potato": "taten gwenwynig",
  "item.minecraft.map": "map gwag",
  "item.minecraft.golden_carrot": "moronen euraid",
  "block.minecraft.skeleton_skull": "penglog sgerbwd",
  "block.minecraft.wither_skeleton_skull": "penglog sgerbwd wither",
  "block.minecraft.player_head": "pen chwaraewr",
  "block.minecraft.zombie_head": "pen sombi",
  "block.minecraft.creeper_head": "pen cripyr",
  "block.minecraft.dragon_head": "pen draig",
  "item.minecraft.carrot_on_a_stick": "moronen ar ffon",
  "item.minecraft.warped_fungus_on_a_stick": "ffwng annaearol ar ffon",
  "item.minecraft.nether_star": "seren nether",
  "item.minecraft.pumpkin_pie": "pei pwmpen",
  "item.minecraft.firework_rocket": "roced tân gwyllt",
  "item.minecraft.firework_star": "seren tân gwyllt",
  "item.minecraft.enchanted_book": "llyfr hudolus",
  "item.minecraft.nether_brick": "bricsen nether",
  "item.minecraft.quartz": "cwarts nether",
  "item.minecraft.tnt_minecart": "cart pwll gyda tnt",
  "item.minecraft.hopper_minecart": "cart pwll gyda hopran",
  "item.minecraft.prismarine_shard": "telchyn prismarin",
  "item.minecraft.prismarine_crystals": "crisialau prismarin",
  "item.minecraft.rabbit": "cwningen amrwd",
  "item.minecraft.cooked_rabbit": "cwningen rhost",
  "item.minecraft.rabbit_stew": "cawl cwningen",
  "item.minecraft.rabbit_foot": "troed cwningen",
  "item.minecraft.rabbit_hide": "croen cwningen",
  "item.minecraft.armor_stand": "daliadur arfwisg",
  "item.minecraft.iron_horse_armor": "arfwisg ceffyl haearn",
  "item.minecraft.golden_horse_armor": "arfwisg ceffyl euraid",
  "item.minecraft.diamond_horse_armor": "arfwisg ceffyl diemwnt",
  "item.minecraft.leather_horse_armor": "arfwisg ceffyl lledr",
  "item.minecraft.lead": "tennyn",
  "item.minecraft.name_tag": "tag enw",
  "item.minecraft.command_block_minecart": "cart pwll gyda bloc gorchymyn",
  "item.minecraft.mutton": "cig dafad amrwd",
  "item.minecraft.cooked_mutton": "cig dafad rhost",
  "block.minecraft.white_banner": "baner wen",
  "block.minecraft.orange_banner": "baner oren",
  "block.minecraft.magenta_banner": "baner majenta",
  "block.minecraft.light_blue_banner": "baner las golau",
  "block.minecraft.yellow_banner": "baner felen",
  "block.minecraft.lime_banner": "baner leim",
  "block.minecraft.pink_banner": "baner binc",
  "block.minecraft.gray_banner": "baner lwyd",
  "block.minecraft.light_gray_banner": "baner lwyd golau",
  "block.minecraft.cyan_banner": "baner wyrddlas",
  "block.minecraft.purple_banner": "baner borffor",
  "block.minecraft.blue_banner": "baner las",
  "block.minecraft.brown_banner": "baner frown",
  "block.minecraft.green_banner": "baner werdd",
  "block.minecraft.red_banner": "baner goch",
  "block.minecraft.black_banner": "baner ddu",
  "item.minecraft.end_crystal": "crisial end",
  "item.minecraft.chorus_fruit": "ffrwyth corws",
  "item.minecraft.popped_chorus_fruit": "ffrwyth corws wedi phopio",
  "item.minecraft.beetroot": "betys",
  "item.minecraft.beetroot_seeds": "hadau betys",
  "item.minecraft.beetroot_soup": "cawl betys",
  "item.minecraft.dragon_breath": "gwynt y ddraig",
  "item.minecraft.splash_potion": "diod tasgu anghrefftadwy□dim effeithiau",
  "item.minecraft.spectral_arrow": "saeth sbectrol",
  "item.minecraft.tipped_arrow": "saeth wedi'i drochi anghrefftadwy□dim effeithiau",
  "item.minecraft.lingering_potion": "diod parhaus anghrefftadwy□dim effeithiau",
  "item.minecraft.shield": "tarian",
  "item.minecraft.elytra": "elytra",
  "item.minecraft.spruce_boat": "cwch pyrwydd",
  "item.minecraft.birch_boat": "cwch bedw",
  "item.minecraft.jungle_boat": "cwch jyngl",
  "item.minecraft.acacia_boat": "cwch acesia",
  "item.minecraft.dark_oak_boat": "cwch derw tywyll",
  "item.minecraft.totem_of_undying": "totem anfarwol",
  "item.minecraft.shulker_shell": "cragen shulker",
  "item.minecraft.iron_nugget": "clap haearn",
  "item.minecraft.knowledge_book": "llyfr gwybodaeth",
  "item.minecraft.debug_stick": "ffon dadfygio",
  "item.minecraft.music_disc_13": "disg cerddoriaeth□c418 - 13",
  "item.minecraft.music_disc_cat": "disg cerddoriaeth□c418 - cat",
  "item.minecraft.music_disc_blocks": "disg cerddoriaeth□c418 - blocks",
  "item.minecraft.music_disc_chirp": "disg cerddoriaeth□c418 - chirp",
  "item.minecraft.music_disc_far": "disg cerddoriaeth□c418 - far",
  "item.minecraft.music_disc_mall": "disg cerddoriaeth□c418 - mall",
  "item.minecraft.music_disc_mellohi": "disg cerddoriaeth□c418 - mellohi",
  "item.minecraft.music_disc_stal": "disg cerddoriaeth□c418 - stal",
  "item.minecraft.music_disc_strad": "disg cerddoriaeth□c418 - strad",
  "item.minecraft.music_disc_ward": "disg cerddoriaeth□c418 - ward",
  "item.minecraft.music_disc_11": "disg cerddoriaeth□c418 - 11",
  "item.minecraft.music_disc_wait": "disg cerddoriaeth□c418 - wait",
  "item.minecraft.music_disc_pigstep": "disg cerddoriaeth□lîna rein - pigstep",
  "item.minecraft.trident": "tryfer□□pan yn y prif law:□+8 difrod ymosod□-2.9 cyflymder ymosod",
  "item.minecraft.phantom_membrane": "pilen ffantom",
  "item.minecraft.nautilus_shell": "cragen bedr",
  "item.minecraft.heart_of_the_sea": "calon y môr",
  "item.minecraft.crossbow": "bwa croes",
  "item.minecraft.suspicious_stew": "cawl amheus",
  "block.minecraft.loom": "gwŷdd",
  "item.minecraft.flower_banner_pattern": "patrwm baner□luws blodyn",
  "item.minecraft.creeper_banner_pattern": "patrwm baner□luws crîpyr",
  "item.minecraft.skull_banner_pattern": "patrwm baner□luws penglog",
  "item.minecraft.mojang_banner_pattern": "patrwm baner□peth",
  "item.minecraft.globe_banner_pattern": "patrwm baner□glôb",
  "item.minecraft.piglin_banner_pattern": "patrwm baner□trwyn",
  "block.minecraft.composter": "compostiwr",
  "block.minecraft.barrel": "casgen",
  "block.minecraft.smoker": "ffwrn fygu",
  "block.minecraft.blast_furnace": "ffwrnais chwyth",
  "block.minecraft.cartography_table": "bwrdd cartograffeg",
  "block.minecraft.fletching_table": "bwrdd pluo",
  "block.minecraft.grindstone": "hogfaen",
  "block.minecraft.lectern": "darllenfa",
  "block.minecraft.smithing_table": "bwrdd gwaith gof",
  "block.minecraft.stonecutter": "naddwr cerrig",
  "block.minecraft.bell": "cloch",
  "block.minecraft.lantern": "llusern",
  "block.minecraft.soul_lantern": "llusern enaid",
  "item.minecraft.sweet_berries": "aeron melys",
  "block.minecraft.campfire": "tân gwersyll",
  "block.minecraft.soul_campfire": "tân gwersyll enaid",
  "block.minecraft.shroomlight": "goleuffwng",
  "item.minecraft.honeycomb": "dil mêl",
  "block.minecraft.bee_nest": "nyth gwenyn",
  "block.minecraft.beehive": "cwch gwenyn",
  "item.minecraft.honey_bottle": "potel fêl",
  "block.minecraft.honey_block": "bloc mêl",
  "block.minecraft.honeycomb_block": "bloc dil mêl",
  "block.minecraft.lodestone": "tynfaen",
  "block.minecraft.netherite_block": "bloc netherit",
  "block.minecraft.ancient_debris": "malurion hynafol",
  "block.minecraft.target": "targed",
  "block.minecraft.crying_obsidian": "wylolosgraig",
  "block.minecraft.blackstone": "carregddu",
  "block.minecraft.blackstone_slab": "slab carregddu",
  "block.minecraft.blackstone_stairs": "grisiau carregddu",
  "block.minecraft.gilded_blackstone": "carregddu euraid",
  "block.minecraft.polished_blackstone": "carregddu caboledig",
  "block.minecraft.polished_blackstone_slab": "slab carregddu caboledig",
  "block.minecraft.polished_blackstone_stairs": "grisiau carregddu caboledig",
  "block.minecraft.chiseled_polished_blackstone": "carregddu caboledig nadd",
  "block.minecraft.polished_blackstone_bricks": "briciau carregddu caboledig",
  "block.minecraft.polished_blackstone_brick_slab": "slab briciau carregddu caboledig",
  "block.minecraft.polished_blackstone_brick_stairs": "grisiau briciau carregddu caboledig",
  "block.minecraft.cracked_polished_blackstone_bricks": "briciau carregddu caboledig chwâl",
  "block.minecraft.respawn_anchor": "angor atgyfodi",
}
export const cy_gb = items; 
